import { State, ActionTypes } from './types';

const initialState: State = {
  avatars: [],
  isLoading: false,
};

const servicesReducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case ActionTypes.GET_AVATARS:
      return {
        ...state,
        isLoading: true,
      };

    case ActionTypes.GET_AVATARS_SUCCESS:
      return {
        ...state,
        avatars: action.payload.data.data,
        isLoading: false
      };

    case ActionTypes.GET_AVATARS_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    default:
      return state;
  }
};

export default servicesReducer;
